let cachedData = []; // Global cache to hold parsed data

document.addEventListener("DOMContentLoaded", function () {
  const metafieldElement = document.getElementById("page-metafields");

  if (metafieldElement) {
    try {
      const subtitleRaw = metafieldElement.dataset.subtitle;
      console.log("Subtitle from metafield:", subtitleRaw);

      // Split CSV rows by line
      const rows = subtitleRaw.trim().split("\n");

      // Get headers
      const headers = rows[0].split(",").map((h) => h.trim());
      console.log("Headers:", headers);

      // Get data rows as array of objects
      const dataRows = rows.slice(1).map((row) =>
        row.split(",").reduce((acc, val, index) => {
          acc[headers[index]] = val.trim();
          return acc;
        }, {})
      );

      // Sort by Total Sales (descending)
      dataRows.sort((a, b) => {
        const totalA =
          parseFloat(a["Total Sales"]?.replace(/[^0-9.-]+/g, "")) || 0;
        const totalB =
          parseFloat(b["Total Sales"]?.replace(/[^0-9.-]+/g, "")) || 0;
        return totalB - totalA;
      });

      // Store and display
      cachedData = dataRows;
      console.log("cachedData", cachedData);
      displayLeaderboard(dataRows);
    } catch (err) {
      console.error("❌ Error:", err);
    }
  }
});

function displayLeaderboard(data) {
  const topFive = data.slice(0, 5);
  const leaderboardContainer = document.getElementById("leaderboard");
  leaderboardContainer.innerHTML = "";

  // Display the leaderboard entries
  topFive.forEach((row, index) => {
    const entry = document.createElement("div");
    entry.className = "leaderboard-entry";
    entry.innerHTML = `
      <span>${index + 1}. ${row[("first_name", "last_name")]}</span>
      <span>${row["Total Sales"]}</span>
    `;
    leaderboardContainer.appendChild(entry);
  });

  // Set the first Display Name as the default value in the input field
  const firstDisplayName = topFive[0][("first_name", "last_name")];
  triggerSearch(firstDisplayName, data);

  // Add a button to view the full leaderboard
  const viewMoreBtn = document.createElement("button");
  viewMoreBtn.className = "view-more-btn";
  viewMoreBtn.textContent = "View Full Event Leaderboard";
  viewMoreBtn.onclick = () => showFullLeaderboard(data);
  leaderboardContainer.appendChild(viewMoreBtn);
}

function triggerSearch(query, data) {
  const inputValue = query.trim().toLowerCase();
  if (!inputValue) return;

  const match = data.find((row) => {
    return (
      // row["Display Name"]?.toLowerCase().includes(inputValue) ||
      row["Email"]?.toLowerCase().includes(inputValue) ||
      row["first_name"]?.toLowerCase().includes(inputValue) ||
      row["last_name"]?.toLowerCase().includes(inputValue)
    );
  });

  displaySearchResult(match);
}

function showFullLeaderboard(data) {
  const modal = document.getElementById("leaderboard-modal");
  const modalContent = document.getElementById("modal-content");

  modalContent.innerHTML = "<h3>Full Event Leaderboard</h3>";

  data.forEach((row, index) => {
    const entry = document.createElement("div");
    entry.className = "modal-entry";
    entry.innerHTML = `
      <span>${index + 1}. ${row[("first_name", "last_name")]}</span>
      <span>${row["Total Sales"]}</span>
    `;
    modalContent.appendChild(entry);
  });

  modal.style.display = "flex";
}

function closeModal() {
  document.getElementById("leaderboard-modal").style.display = "none";
}

// Unified search logic
document.getElementById("search-form").addEventListener("submit", (e) => {
  e.preventDefault();

  const inputValue = document
    .getElementById("search-all")
    .value.trim()
    .toLowerCase();

  if (!inputValue) return;

  const match = cachedData.find((row) => {
    return (
      // row["Display Name"]?.toLowerCase().includes(inputValue) ||
      row["Email"]?.toLowerCase().includes(inputValue) ||
      row["first_name"]?.toLowerCase().includes(inputValue) ||
      row["last_name"]?.toLowerCase().includes(inputValue)
    );
  });

  console.log("match", match);
  console.log("cachedData1", cachedData); // Add this line before the match block

  displaySearchResult(match);
});

function displaySearchResult(result) {
  const nameEl = document.getElementById("displayName");
  const salesInfoEl = document.getElementById("salesInfo");
  const percentageTextEl = document.getElementById("percentageText");
  const fillEl = document.querySelector(".progress-fill1");

  if (!result) {
    nameEl.textContent = "";
    salesInfoEl.textContent = "No match found.";

    return;
  }

  const totalSales = parseFloat(
    result["Total Sales"].replace(/[^0-9.-]+/g, "")
  );
  const goal = 900;
  const percentage = Math.min((totalSales / goal) * 100, 100).toFixed(2);

  nameEl.textContent = result[("first_name", "last_name")];
  salesInfoEl.textContent = `${result["Total Sales"]} sold of $${goal} goal`;
  percentageTextEl.textContent = `${percentage}% of goal reached`;

  fillEl.style.width = "0%";
  setTimeout(() => {
    fillEl.style.width = `${percentage}%`;
  }, 50);
}

document.addEventListener("DOMContentLoaded", function () {
  const metafieldElement1 = document.getElementById("page-metafields2");

  if (metafieldElement1) {
    try {
      const subtitleRaw1 = metafieldElement1.dataset.subtitle;
      console.log("Subtitle from metafield2:", subtitleRaw1);

      // Function to render the CSV data
      function renderCSVData1(csvData) {
        const rows1 = csvData.trim().split("\n");
        const headers1 = rows1[0].split(","); // Use rows1 here
        const entries1 = rows1.slice(1).map((row) => {
          const cols1 = row.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
          return headers1.reduce((obj, key, idx) => {
            obj[key.trim()] = cols1[idx]?.replace(/^"|"$/g, "").trim();
            return obj;
          }, {});
        });

        // Sort the entries by lastdate (if available) in descending order
        entries1.sort((a, b) => {
          const dateA = new Date(a.lastdate);
          const dateB = new Date(b.lastdate);
          return dateB - dateA; // Sort descending
        });

        const reversedEntries = [...entries1].reverse(); // Reverse the order

        console.log("Reversed Entries:", reversedEntries);

        const list = document.getElementById("support-list");
        const fullList = document.getElementById("full-support-list");
        const viewBtn = document.getElementById("view-full");
        const modal = document.getElementById("support-modal");
        const closeBtn = document.querySelector(".close-btn1");

        function createSupporterHTML(entry) {
          const container = document.createElement("li");

          const topRow = document.createElement("div");
          topRow.className = "supporter-top";
          topRow.innerHTML = `<span>${entry.name || "Anonymous"}</span><span>${
            entry.currency || ""
          } ${entry.price}</span>`;

          const location = document.createElement("div");
          location.className = "supporter-location";
          location.textContent = `${entry.lastdate} - ${
            entry.address || "Unknown"
          }`;

          container.appendChild(topRow);
          container.appendChild(location);

          if (entry.message) {
            const message = document.createElement("div");
            message.className = "supporter-message";
            message.textContent = entry.message;
            container.appendChild(message);
          }

          return container;
        }

        list.innerHTML = "";
        reversedEntries.slice(0, 5).forEach((entry) => {
          list.appendChild(createSupporterHTML(entry));
        });

        fullList.innerHTML = "";
        reversedEntries.forEach((entry) => {
          fullList.appendChild(createSupporterHTML(entry));
        });

        // Modal Show/Hide Logic
        if (viewBtn && modal && closeBtn) {
          viewBtn.addEventListener("click", () => {
            modal.style.display = "block";
          });

          closeBtn.addEventListener("click", () => {
            modal.style.display = "none";
          });

          window.addEventListener("click", (event) => {
            if (event.target === modal) {
              modal.style.display = "none";
            }
          });
        }
      }

      // Call the renderCSVData1 function to display data
      renderCSVData1(subtitleRaw1);
    } catch (err) {
      console.error("❌ Error:", err);
    }
  }
});
